import { Typography } from '@mui/material';
import { Skeleton } from '@mui/material';

type TitledMessageProps = {
  loading?: boolean;
  title: string;
  message: string;
  center?: boolean;
};
const TitledMessage = ({ title, message, center, loading }: TitledMessageProps) => (
  <>
    <Typography align={center ? 'center' : undefined}>{loading ? <Skeleton /> : title}</Typography>
    <Typography
      variant="caption"
      align={center ? 'center' : undefined}
      component="p"
      style={{ marginBottom: '16px' }}
    >
      {loading ? <Skeleton /> : message}
    </Typography>
  </>
);

export default TitledMessage;
